module.exports = __webpack_public_path__ + "static/media/facebook.9ce8b343.svg";